
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-[600px] flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-pink-800 overflow-hidden"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20music%20streaming%20platform%20hero%20background%20with%20abstract%20sound%20waves%2C%20purple%20and%20pink%20gradients%2C%20dynamic%20flowing%20patterns%2C%20futuristic%20digital%20music%20visualization%2C%20left%20side%20darker%20for%20text%20overlay&width=1400&height=600&seq=hero-bg&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-purple-900/90 via-purple-800/70 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Your Music,
              <span className="block bg-gradient-to-r from-pink-400 to-purple-300 bg-clip-text text-transparent">
                Your World
              </span>
            </h1>
            <p className="text-xl text-purple-100 mb-8 leading-relaxed">
              Discover millions of songs, create playlists, and share your music with the world. 
              Join the ultimate music streaming experience.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="text-lg px-8 py-4">
                <i className="ri-play-circle-fill mr-2 text-xl"></i>
                Start Listening
              </Button>
              <Button variant="outline" size="lg" className="text-lg px-8 py-4 border-white text-white hover:bg-white hover:text-purple-900">
                <i className="ri-upload-cloud-2-line mr-2 text-xl"></i>
                Upload Your Music
              </Button>
            </div>
            <div className="flex items-center space-x-8 mt-8 text-purple-200">
              <div>
                <div className="text-2xl font-bold text-white">50M+</div>
                <div className="text-sm">Songs</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-white">10M+</div>
                <div className="text-sm">Artists</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-white">100M+</div>
                <div className="text-sm">Users</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
